import * as request from "../lib/lib";
import Swal from 'sweetalert2'

const baseUrl = process.env.REACT_APP_BACKEND_URL + 'GetInfo';


export const getAll = async () => {
    const result = await request.get(`${baseUrl}/Rules`);

    const data = Object.values(result);

    return data;
};

export const create = async (formData) => {

    const contentType = 'multipart/form-data';
    let result = null;


    try {
        result = await request.postFile(`${baseUrl}/Rules`, formData, contentType);
        Swal.fire({ title: "Успешно добавена наредба!", text: "", icon: "success" });
    } catch (error) {
        Swal.fire({ title: "Грешка добавяне на наредби!", text: error.message, icon: "error" });
    }

    const data = Object.values(result);

    return data;
};

export const del = async (fileName) => {
    const result = await request.post(`${baseUrl}/Rules/${fileName}`);

    const data = Object.values(result);

    return data;
};


export const edit = async (id, title) => {
    const result = await request.put(`${baseUrl}/Rules/${id}`,title);

    return result;
};

export const OrderRules = async (payload) => {
    
    const contentType = 'application/json';
    //const data = JSON.stringify(payload);

    const result = await request.post(`${baseUrl}/OrderRules`, payload , contentType);

    return result;
};


/*export const OrderRules = async () => {
    const result = await request.get(`${baseUrl}/Rules`);

    const data = Object.values(result);

    return data;
};
*/



